import { api } from "@/lib/api";

const enc = encodeURIComponent;

// Inbox
export const listAdminTickets = async (status) =>
  (await api.get("/admin/tickets", { params: status ? { status } : undefined })).data.tickets;
export const replyTicket = async (id, message) => (await api.post(`/admin/tickets/${enc(id)}/reply`, { message })).data;
export const closeTicket = async (id) => (await api.post(`/admin/tickets/${enc(id)}/close`)).data;
export const listQuoteRequests = async (status) =>
  (await api.get("/admin/quote-requests", { params: status ? { status } : undefined })).data.quote_requests;
export const updateQuoteRequest = async (id, body) => (await api.patch(`/admin/quote-requests/${enc(id)}`, body)).data;

// Settings / public settings
export const getPublicSiteSettings = async () => (await api.get("/site-settings")).data;
export const getAdminSiteSettings = async () => (await api.get("/admin/site-settings")).data;
export const putAdminSiteSettings = async (body) => (await api.put("/admin/site-settings", body)).data;

// Discounts
export const listDiscountCodes = async () => (await api.get("/admin/discount-codes")).data.discount_codes;
export const createDiscountCode = async (body) => (await api.post("/admin/discount-codes", body)).data;
export const patchDiscountCode = async (code, body) => (await api.patch(`/admin/discount-codes/${enc(code)}`, body)).data;
export const deleteDiscountCode = async (code) => (await api.delete(`/admin/discount-codes/${enc(code)}`)).data;

// Pages
export const listAdminPages = async () => (await api.get("/admin/pages")).data.pages;
export const putAdminPage = async (slug, body) => (await api.put(`/admin/pages/${enc(slug)}`, body)).data;

// Testimonials — owner-entered only, never generated (see server.py comment).
export const listTestimonials = async () => (await api.get("/admin/testimonials")).data.testimonials;
export const createTestimonial = async (body) => (await api.post("/admin/testimonials", body)).data;
export const patchTestimonial = async (id, body) => (await api.patch(`/admin/testimonials/${enc(id)}`, body)).data;
export const deleteTestimonial = async (id) => (await api.delete(`/admin/testimonials/${enc(id)}`)).data;

// Consulting
export const grantConsulting = async (searchId, placeId, source) =>
  (await api.post(`/searches/${enc(searchId)}/businesses/${enc(placeId)}/consulting/grant`, { source })).data;

// Mail test
export const postMailTest = async () => (await api.post("/admin/mail-test")).data;

// Orders (Stripe)
export const listOrders = async (status) =>
  (await api.get("/admin/orders", { params: status ? { status } : undefined })).data.orders;
export const patchOrder = async (id, body) => (await api.patch(`/admin/orders/${enc(id)}`, body)).data;

// Bulk completion of missing measurements (real DataForSEO spend on run)
export const getBackfillPlan = async () => (await api.get("/admin/backfill/plan")).data;
export const runBackfill = async (max_usd) => (await api.post("/admin/backfill/run", { max_usd, confirm: true })).data;
export const getBackfillStatus = async () => (await api.get("/admin/backfill/status")).data;

// Sector keyword sets (discover spends real DataForSEO money)
export const listKeywordSets = async () => (await api.get("/admin/keyword-sets")).data.keyword_sets;
export const putKeywordSet = async (slug, body) => (await api.put(`/admin/keyword-sets/${enc(slug)}`, body)).data;
export const deleteKeywordSet = async (slug) => (await api.delete(`/admin/keyword-sets/${enc(slug)}`)).data;
export const getDiscoverPlan = async (seed) => (await api.get("/admin/keyword-sets/discover-plan", { params: { seed } })).data;
export const discoverKeywordSet = async (seed) => (await api.post("/admin/keyword-sets/discover", { seed, confirm: true })).data;
